export default __webpack_public_path__ + "static/media/about3title.178ae524.png";